__turbopack_context__.v({
  "Description": "index-module__lerEpq__Description",
  "Field": "index-module__lerEpq__Field",
  "Input": "index-module__lerEpq__Input",
  "InputInvalidA": "index-module__lerEpq__InputInvalidA",
  "InputInvalidB": "index-module__lerEpq__InputInvalidB",
  "Label": "index-module__lerEpq__Label",
  "Root": "index-module__lerEpq__Root",
  "ScreenReaderOnly": "index-module__lerEpq__ScreenReaderOnly",
  "otp-field-shake-a": "index-module__lerEpq__otp-field-shake-a",
  "otp-field-shake-b": "index-module__lerEpq__otp-field-shake-b",
});
